import {
  CollegeCurrentSchoolCity,
  CollegeCurrentSchoolCountry,
  CollegeCurrentSchoolInternationalRegion,
  CollegeCurrentSchoolName,
  CollegeCurrentSchoolState,
} from "@up/application-fields";
import { RenderElement } from "@up/form";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { range } from "@up/ui";

import type { ReactNode } from "react";

const GRADUATE_SCHOOL_OPTIONS = [
  "Business School (MBA)",
  "Law School",
  "Medical School",
  "Nursing School (MSN/DNP)",
  "Graduate School (Master's or Ph.D.)",
  "Public Health (MPH)",
  "Public Policy or Government",
  "Communications or Media",
  "Engineering or Technology",
  "Other",
  "Not sure yet",
  "Not interested at this time",
].map((option) => ({ text: option, value: option }));

function PlanAttendingGraduateSchool() {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <div className="mb-8">
      <label className="kup-label mb-1">
        <span className="kup-label-text">
          Are you interested in pursuing graduate or professional education?
          <span className="kup-label-required-flag">*</span>
        </span>
      </label>
      <RenderElement
        control={control}
        element={{
          _id: "college-plan-attending-graduate-school",
          type: "checkbox",
          name: "college-plan-attending-graduate-school",
          options: GRADUATE_SCHOOL_OPTIONS,
          validate: { presence: true },
          meta: { columns: 2 },
        }}
        errors={errors}
        formValues={formValues}
        register={register}
      />
    </div>
  );
}

function YearAttendingGraduateSchool({
  label = "What year do you plan to begin?",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const KEY = "college-year-attending-graduate-school";
  const VALIDATION = { presence: true };
  const CURRENT_YEAR = new Date().getFullYear();
  const OPTIONS = range(CURRENT_YEAR + 5, CURRENT_YEAR - 20, -1);
  const LABEL = label;

  return (
    <RenderElement
      control={control}
      element={{
        _id: KEY,
        type: "select",
        label: LABEL,
        name: KEY,
        options: OPTIONS,
        validate: VALIDATION,
        meta: {
          type: "year",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}

export function AcademicInformationPageAdult({
  bottom,
}: {
  bottom: () => ReactNode;
}) {
  const formValues = useWatch();

  return (
    <>
      <h2 className="heading-4 mb-4">College Attending/Attended</h2>

      <fieldset className="kup-fieldset">
        <legend hidden>Current School</legend>

        <CollegeCurrentSchoolName label="Name of College" />

        <CollegeCurrentSchoolCountry label="Country" />

        <div className="grid-cols-2 gap-4 md:grid">
          <CollegeCurrentSchoolCity label="City" />
          <CollegeCurrentSchoolState label="State" />
          <CollegeCurrentSchoolInternationalRegion label="State/Province/Region" />
        </div>
      </fieldset>

      <PlanAttendingGraduateSchool />

      {Array.isArray(formValues["college-plan-attending-graduate-school"]) &&
        formValues["college-plan-attending-graduate-school"].some(
          (v) => v !== "Not sure yet" && v !== "Not interested at this time",
        ) && <YearAttendingGraduateSchool />}

      {bottom()}
    </>
  );
}
